var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section credit-info-form",
      staticStyle: { height: "auto" }
    },
    [
      _c("div", { staticStyle: { display: "flex" } }, [
        _c("div", [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CurrentCredit")))
          ]),
          _c(
            "div",
            { staticClass: "box-content" },
            [
              _c(
                "div",
                { staticClass: "inner-row" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "form-item-350",
                      attrs: {
                        disabled:
                          _vm.readonly ||
                          _vm.creditDisable ||
                          _vm.normalRuleContactExist,
                        inline: true,
                        "label-width": _vm.isZh ? "80px" : "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "margin-Right50",
                          attrs: { label: _vm.$t("Partners.dateType") }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { no: "remarks" },
                              model: {
                                value: _vm.currentOnlyCreditInfo.remarks,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.currentOnlyCreditInfo,
                                    "remarks",
                                    $$v
                                  )
                                },
                                expression: "currentOnlyCreditInfo.remarks"
                              }
                            },
                            _vm._l(_vm.DATETYPE_TYPE, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.$getLangColumn(item),
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Invoice.invoice_settlementMethod")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { no: "val1" },
                                  model: {
                                    value: _vm.creditDateTypeObj.val1,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.creditDateTypeObj,
                                        "val1",
                                        $$v
                                      )
                                    },
                                    expression: "creditDateTypeObj.val1"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "Partners.monthlySettlement"
                                      ),
                                      value: -1
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_SettleByWeekly"
                                      ),
                                      value: -2
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_FixedDateMonthly"
                                      ),
                                      value: "n"
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.space5"),
                                      value: -3
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.dailySettlement"),
                                      value: -4
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("el-input-number", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.creditDateTypeObj.val1 === "n",
                                    expression: "creditDateTypeObj.val1==='n'"
                                  }
                                ],
                                attrs: {
                                  no: "val2",
                                  value:
                                    _vm.creditDateTypeObj.val2 || undefined,
                                  min: 0,
                                  precision: 0,
                                  controls: false
                                },
                                on: {
                                  input: function(val) {
                                    _vm.creditDateTypeObj.val2 = val
                                  }
                                }
                              }),
                              !_vm.isZy
                                ? _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: {
                                        no: "blacklist",
                                        disabled: _vm.oujianEditLimit
                                      },
                                      on: { change: _vm.handleBlacklistChange },
                                      model: {
                                        value: _vm.form.blacklist,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "blacklist", $$v)
                                        },
                                        expression: "form.blacklist"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("Partners.blacklist"))
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _c("br"),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "margin-Right50",
                          attrs: { label: _vm.$t("Partners.accountPeriod") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  no: "creditDateLimited",
                                  min: 0,
                                  precision: 0,
                                  "controls-position": "right"
                                },
                                model: {
                                  value:
                                    _vm.currentOnlyCreditInfo.creditDateLimited,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.currentOnlyCreditInfo,
                                      "creditDateLimited",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "currentOnlyCreditInfo.creditDateLimited"
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticStyle: {
                                    width: "200px",
                                    "margin-left": "5px"
                                  },
                                  attrs: { no: "termUnit" },
                                  model: {
                                    value: _vm.currentOnlyCreditInfo.termUnit,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.currentOnlyCreditInfo,
                                        "termUnit",
                                        $$v
                                      )
                                    },
                                    expression: "currentOnlyCreditInfo.termUnit"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.day"),
                                      value: 0
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.week"),
                                      value: 1
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.month"),
                                      value: 2
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Partners.limit") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  no: "credit",
                                  min: 0,
                                  precision: 0,
                                  controls: false
                                },
                                model: {
                                  value: _vm.currentOnlyCreditInfo.credit,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.currentOnlyCreditInfo,
                                      "credit",
                                      $$v
                                    )
                                  },
                                  expression: "currentOnlyCreditInfo.credit"
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticStyle: {
                                    "margin-left": "5px",
                                    width: "200px"
                                  },
                                  attrs: { no: "currency" },
                                  on: { change: _vm.currencyChanged },
                                  model: {
                                    value: _vm.currentOnlyCreditInfo.currency,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.currentOnlyCreditInfo,
                                        "currency",
                                        $$v
                                      )
                                    },
                                    expression: "currentOnlyCreditInfo.currency"
                                  }
                                },
                                _vm._l(_vm.currencySet, function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.code,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "inner-row" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "form-item-350",
                      attrs: {
                        disabled: _vm.readonly,
                        inline: true,
                        "label-width": _vm.isZh ? "80px" : "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "margin-Right50",
                          staticStyle: { width: "auto" },
                          attrs: { label: _vm.$t("Payment.settlementType") }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                no: "settlementType",
                                disabled: true,
                                value: _vm.settlementType
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                { attrs: { no: "byTicket", label: true } },
                                [_vm._v(_vm._s(_vm.$t("Message.ByTicket")))]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: {
                                    no: "settlementNotByBill",
                                    label: false
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Partners.settlementNotByBill")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_EtdDays") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "auto" } },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  no: "etdDays",
                                  min: 0,
                                  max: 999,
                                  precision: 0,
                                  "controls-position": "right"
                                },
                                model: {
                                  value: _vm.currentOnlyCreditInfo.etdDays,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.currentOnlyCreditInfo,
                                      "etdDays",
                                      $$v
                                    )
                                  },
                                  expression: "currentOnlyCreditInfo.etdDays"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "inner-row" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "form-item-350",
                      attrs: {
                        disabled: _vm.readonly,
                        inline: true,
                        "label-width": _vm.isZh ? "80px" : "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "margin-Right50",
                          staticStyle: { width: "auto" },
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_RemainingTemporaryReleaseQuantity"
                            )
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { width: "auto" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.form.tempNumberAllocation,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "tempNumberAllocation",
                                      $$v
                                    )
                                  },
                                  expression: "form.tempNumberAllocation"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("hr", { staticStyle: { margin: "8px 1px" } }),
              _c(
                "div",
                { staticClass: "inner-row" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "form-item-350",
                      attrs: {
                        inline: true,
                        "label-width": _vm.isZh ? "80px" : "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "margin-Right50" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "title",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_ContractCredit"))
                              )
                            ]
                          ),
                          _c(
                            "el-select",
                            {
                              staticClass: "form-item-350",
                              attrs: {
                                value: _vm.currentContract.uuid,
                                no: "contractRuleUuid"
                              },
                              on: { change: _vm.contractChange }
                            },
                            _vm._l(_vm.contractList, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label:
                                    item.ruleName +
                                    (item.contractNo
                                      ? "【" + item.contractNo + "】"
                                      : ""),
                                  value: item.uuid
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "inner-row" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "form-item-350",
                      attrs: {
                        disabled: "",
                        inline: true,
                        "label-width": _vm.isZh ? "80px" : "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "margin-Right50",
                          attrs: { label: _vm.$t("Partners.dateType") }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { no: "contractRemarks" },
                              model: {
                                value: _vm.contractCreditInfo.remarks,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.contractCreditInfo,
                                    "remarks",
                                    $$v
                                  )
                                },
                                expression: "contractCreditInfo.remarks"
                              }
                            },
                            _vm._l(_vm.DATETYPE_TYPE, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: _vm.$getLangColumn(item),
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("Invoice.invoice_settlementMethod")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { no: "contractVal1" },
                                  model: {
                                    value: _vm.contractCreditDateTypeObj.val1,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.contractCreditDateTypeObj,
                                        "val1",
                                        $$v
                                      )
                                    },
                                    expression: "contractCreditDateTypeObj.val1"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "Partners.monthlySettlement"
                                      ),
                                      value: -1
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_SettleByWeekly"
                                      ),
                                      value: -2
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_FixedDateMonthly"
                                      ),
                                      value: "n"
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.space5"),
                                      value: -3
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.dailySettlement"),
                                      value: -4
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("el-input-number", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.contractCreditDateTypeObj.val1 ===
                                      "n",
                                    expression:
                                      "contractCreditDateTypeObj.val1==='n'"
                                  }
                                ],
                                attrs: {
                                  no: "contractVal2",
                                  value:
                                    _vm.contractCreditDateTypeObj.val2 ||
                                    undefined,
                                  min: 0,
                                  precision: 0,
                                  controls: false
                                },
                                on: {
                                  input: function(val) {
                                    _vm.contractCreditDateTypeObj.val2 = val
                                  }
                                }
                              }),
                              !_vm.isZy
                                ? _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: { no: "contractBlacklist" },
                                      on: { change: _vm.handleBlacklistChange },
                                      model: {
                                        value: _vm.form.blacklist,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "blacklist", $$v)
                                        },
                                        expression: "form.blacklist"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("Partners.blacklist"))
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      ),
                      _c("br"),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "margin-Right50",
                          attrs: { label: _vm.$t("Partners.accountPeriod") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  no: "contractCreditDateLimited",
                                  min: 0,
                                  precision: 0,
                                  "controls-position": "right"
                                },
                                model: {
                                  value:
                                    _vm.contractCreditInfo.creditDateLimited,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contractCreditInfo,
                                      "creditDateLimited",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "contractCreditInfo.creditDateLimited"
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticStyle: {
                                    width: "200px",
                                    "margin-left": "5px"
                                  },
                                  attrs: { no: "contractTermUnit" },
                                  model: {
                                    value: _vm.contractCreditInfo.termUnit,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.contractCreditInfo,
                                        "termUnit",
                                        $$v
                                      )
                                    },
                                    expression: "contractCreditInfo.termUnit"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.day"),
                                      value: 0
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.week"),
                                      value: 1
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.month"),
                                      value: 2
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Partners.limit") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  no: "contractCredit",
                                  min: 0,
                                  precision: 0,
                                  controls: false
                                },
                                model: {
                                  value: _vm.contractCreditInfo.credit,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contractCreditInfo,
                                      "credit",
                                      $$v
                                    )
                                  },
                                  expression: "contractCreditInfo.credit"
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticStyle: {
                                    "margin-left": "5px",
                                    width: "200px"
                                  },
                                  attrs: { no: "contractCurrency" },
                                  on: { change: _vm.currencyChanged },
                                  model: {
                                    value: _vm.contractCreditInfo.currency,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.contractCreditInfo,
                                        "currency",
                                        $$v
                                      )
                                    },
                                    expression: "contractCreditInfo.currency"
                                  }
                                },
                                _vm._l(_vm.currencySet, function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.code,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c("br"),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showActualCreditGracePeriodDays,
                              expression: "showActualCreditGracePeriodDays"
                            }
                          ],
                          staticClass: "margin-Right50",
                          attrs: { label: _vm.$t("Payment.paymentPeriod") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input-number", {
                                staticStyle: { width: "300px" },
                                attrs: {
                                  no: "paymentTerm",
                                  min: 0,
                                  precision: 0,
                                  "controls-position": "right"
                                },
                                model: {
                                  value: _vm.contractCreditInfo.paymentTerm,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.contractCreditInfo,
                                      "paymentTerm",
                                      $$v
                                    )
                                  },
                                  expression: "contractCreditInfo.paymentTerm"
                                }
                              }),
                              _c(
                                "el-select",
                                {
                                  staticStyle: {
                                    width: "200px",
                                    "margin-left": "5px"
                                  },
                                  attrs: { no: "paymentTermUnit" },
                                  model: {
                                    value:
                                      _vm.contractCreditInfo.paymentTermUnit,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.contractCreditInfo,
                                        "paymentTermUnit",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "contractCreditInfo.paymentTermUnit"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.day"),
                                      value: 0
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.week"),
                                      value: 1
                                    }
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("Partners.month"),
                                      value: 2
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "inner-row" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        disabled: "",
                        inline: true,
                        "label-width": _vm.isZh ? "80px" : "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Payment.settlementType") } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                no: "contractSettlementType",
                                disabled: true,
                                value: _vm.contractSettlementType
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { no: "contractByTicket", label: true }
                                },
                                [_vm._v(_vm._s(_vm.$t("Message.ByTicket")))]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: {
                                    no: "contractSettlementNotByBill",
                                    label: false
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Partners.settlementNotByBill")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-tabs",
                {
                  staticStyle: {
                    width: "100%",
                    height: "100%",
                    "margin-bottom": "8px"
                  },
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeTabName,
                    callback: function($$v) {
                      _vm.activeTabName = $$v
                    },
                    expression: "activeTabName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.Cargo_TempCredit"),
                        name: "otherDocuments"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "app-main-inner-row row-grid",
                          staticStyle: { "min-height": "300px" }
                        },
                        [
                          _c("cargo-ag-grid", {
                            staticStyle: {
                              height: "100%",
                              "min-height": "220px"
                            },
                            attrs: {
                              "column-defs": _vm.tempCreditInfo.columnDefs,
                              "grid-options": _vm.tempCreditInfo.gridOptions,
                              "row-data": _vm.tempCreditInfo.rowData,
                              "show-side-bar": false
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c("hr", { staticStyle: { margin: "8px 1px" } }),
              _c(
                "div",
                { staticClass: "inner-row" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "form-item-350",
                      attrs: {
                        disabled: _vm.readonly,
                        inline: true,
                        "label-width": _vm.isZh ? "80px" : "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Payment.isReceivable") } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              attrs: { no: "receivableDeposit" },
                              on: { change: _vm.changeReceivableDeposit },
                              model: {
                                value: _vm.checkedList,
                                callback: function($$v) {
                                  _vm.checkedList = $$v
                                },
                                expression: "checkedList"
                              }
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    no: "receipt",
                                    label: true,
                                    checked: _vm.form.receivableDeposit
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("Payment.receipt")))]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    no: "payment",
                                    label: false,
                                    checked: !_vm.form.receivableDeposit
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("Payment.payment")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("br"),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "margin-Right50",
                          attrs: { label: _vm.$t("Partners.depositAmount") }
                        },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "depositAmount",
                              min: 0,
                              max: 9999999,
                              "controls-position": "right"
                            },
                            model: {
                              value: _vm.form.depositAmount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "depositAmount", $$v)
                              },
                              expression: "form.depositAmount"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Payment.payReceiveDate") } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              no: "depositDate",
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.form.depositDate,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "depositDate", $$v)
                              },
                              expression: "form.depositDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c("br"),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "margin-Right50",
                          attrs: {
                            label: _vm.$t(
                              "WriteOff.revenueAndExpenditureMethod"
                            )
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { no: "depositType" },
                              model: {
                                value: _vm.form.depositType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "depositType", $$v)
                                },
                                expression: "form.depositType"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("SeaExport.Cash"),
                                  value: 0
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("SeaExport.Check"),
                                  value: 1
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("SeaExport.Transfer"),
                                  value: 2
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("Partners.space8"),
                                  value: 3
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("Partners.space9"),
                                  value: 4
                                }
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("Partners.space10"),
                                  value: 5
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("Partners.depositCurrency") }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "depositCurrency",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Currency,
                              filterable: "",
                              clearable: false,
                              "default-value": _vm.form.depositCurrency
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.form.depositCurrency = p.value
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c("br"),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.AdditionalNotes") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "depositCurrency",
                              type: "textarea",
                              rows: 3
                            },
                            model: {
                              value: _vm.form.creditRemarks,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "creditRemarks", $$v)
                              },
                              expression: "form.creditRemarks"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.tipVisible
            ? _c("span", { staticStyle: { color: "red" } }, [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_Prompt")) +
                    "：" +
                    _vm._s(
                      _vm.$t("Partners.adjustContractInformationInBasicData")
                    )
                )
              ])
            : _vm._e()
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.readonly ||
                  _vm.creditDisable ||
                  _vm.normalRuleContactExist,
                expression:
                  "readonly || creditDisable || normalRuleContactExist"
              }
            ],
            staticStyle: { width: "300px", "margin-left": "15px" }
          },
          [
            _c("cargo-ag-grid", {
              staticStyle: { "max-height": "325px" },
              attrs: {
                "config-module": "2022080401",
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.rowData
              }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }